<button
  *ngIf="showTrigger"
  type="button"
  class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg row-sm-start-center transition-colors"
  (click)="openQrScanner()"
  title="Scan QR Code"
>
  <i class="pi pi-qrcode"></i>
  <span>Scan QR</span>
</button>
<!-- QR Scanner Modal -->
<div *ngIf="showQrScanner" class="absolute inset-0 bg-black bg-opacity-50 row-center-center" style="z-index: 1">
  <div class="bg-white rounded-lg p-6 m-4 w-full max-w-md">
    <div class="row-between-center mb-4">
      <h3 class="text-lg font-semibold">QR/Barcode Scanner</h3>
      <button (click)="closeQrScanner()" class="text-gray-400 hover:text-gray-600 text-xl">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <app-qr-scanner (code)="onQrCodeScanned($event)" (scanError)="onQrScanError($event)" [showFileUpload]="false" [showFramingGuide]="true"> </app-qr-scanner>
  </div>
</div>
